import { ChangeDetectionStrategy, Component, effect, inject, input } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { AionzTooltip } from '@aionzdev/design-system';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'aionz-kanban-chip-badge',
  standalone: true,
  imports: [MatIconModule, AionzTooltip],
  templateUrl: './kanban-chip-badge.component.html',
  styleUrl: './kanban-chip-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KanbanChipBadgeComponent {
  private iconRegistry = inject(MatIconRegistry);
  private domSanitizer = inject(DomSanitizer);

  public label = input.required<string>();
  public icon = input<string | null>(null);
  public svgIcon = input<string | null>(null);
  public disabled = input<boolean>(false);
  public compact = input<boolean>(false);
  public color = input<string | null>(null);
  public tooltip = input<string | null>(null);
  /** Texto lido pelo leitor de tela no lugar do rótulo visível, quando ele sozinho não se explica (ex.: só um número). */
  public srLabel = input<string | null>(null);

  constructor() {
    effect(() => {
      const svgIconName = this.svgIcon();
      if (!svgIconName) {
        return;
      }

      this.iconRegistry.addSvgIcon(
        svgIconName,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/icons/svg/${svgIconName}.svg`)
      );
    });
  }
}
